import BaseLayer from "./BaseLayer";
import {plotDisagreementsHelper} from "../utils/map_utils";

class StitchPostRound2Disagreementv2 extends BaseLayer {

    id = "stitchPostRound2Disagreementv2";
    label = "After";
    defaultVisible = this.props.tileViewerState[this.id];

    draw = () => new Promise((resolve, reject) => {
        let {stitchPostR2Disagreement, textColor} = this.props;
        plotDisagreementsHelper(stitchPostR2Disagreement.result, this.props.slide, this.layer.getSource(), textColor);
        resolve();
    });
}

export default StitchPostRound2Disagreementv2;
